import { render, staticRenderFns } from "./mainbox.vue?vue&type=template&id=8843d15c&"
import script from "./mainbox.vue?vue&type=script&defer=true&lang=js&"
export * from "./mainbox.vue?vue&type=script&defer=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports